<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    open: {
        type: Boolean,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    withTypingConfirmation: {
        type: Boolean,
        required: false,
        default: false,
    },
    confirmationWord: {
        type: String,
        required: false,
        default: 'delete',
    },
});

const emit = defineEmits(['close', 'cancel', 'confirm']);

const confirmInput = ref('');

const isConfirmed = computed(() => {
    return (
        !props.withTypingConfirmation || (props.withTypingConfirmation && confirmInput.value === props.confirmationWord)
    );
});

const updateInput = (e) => {
    confirmInput.value = e.target.value;
};

const handleConfirm = () => {
    if (isConfirmed.value) {
        emit('confirm');
    }
};
</script>

<template>
    <nord-modal
        id="delete-confirmation-modal"
        size="s"
        :open="open"
        aria-labelledby="title"
        @close="emit('close')"
        @cancel="emit('cancel')"
    >
        <h2 slot="header" id="title">
            {{ title }}
        </h2>

        <div class="n-reset">
            <slot />

            <div id="confirmation-input-wrapper" v-if="withTypingConfirmation" class="mt-8">
                <div>
                    {{ trans('global.please_type') }}
                    "<span class="font-bold text-danger">{{ confirmationWord }}</span>"
                    {{ trans('global.to_confirm') }}
                </div>

                <nord-input
                    id="confirmation-input"
                    :value="confirmInput"
                    @input="updateInput"
                    :placeholder="`${trans('global.type')} ${confirmationWord} ${trans('global.here')}`"
                    hide-label
                    expand
                />
            </div>
        </div>

        <nord-button-group slot="footer" variant="spaced">
            <nord-button id="cancel-button" @click="emit('cancel')" expand>
                {{ trans('global.close') }}
            </nord-button>

            <nord-button
                id="confirm-button"
                :disabled="!isConfirmed"
                @click="handleConfirm"
                expand
                variant="danger"
                autofocus
            >
                {{ trans('global.delete') }}
            </nord-button>
        </nord-button-group>
    </nord-modal>
</template>
